// frontend/src/components/common/TrialBanner.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, X } from 'lucide-react';
import api from '../../utils/api';

export default function TrialBanner() {
  const [trialInfo, setTrialInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function fetchTrialStatus() {
      try {
        const res = await api.get('/api/user/trial-status');
        if (!cancelled) setTrialInfo(res.data);
      } catch {
        // Ignore — banner just won't show
      }
    }
    fetchTrialStatus();
    return () => { cancelled = true; };
  }, []);

  // Don't show if: already subscribed, not on trial, dismissed, or still loading
  if (!trialInfo || trialInfo.subscribed || !trialInfo.trial || dismissed) return null;

  const { daysRemaining } = trialInfo;
  const isUrgent = daysRemaining <= 3;

  return (
    <div className={`flex items-center justify-between px-4 py-2 text-sm ${
      isUrgent
        ? 'bg-amber-50 border-b border-amber-200 text-amber-800'
        : 'bg-blue-50 border-b border-blue-200 text-blue-800'
    }`}>
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 flex-shrink-0" />
        <span>
          {daysRemaining === 1
            ? 'Last day of your free trial!'
            : `${daysRemaining} days left in your free trial.`}
        </span>
        <Link
          to="/dashboard/billing"
          className={`font-semibold underline ${
            isUrgent ? 'text-amber-900' : 'text-blue-900'
          }`}
        >
          Subscribe now
        </Link>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 rounded hover:bg-black/5"
        aria-label="Dismiss trial banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
